import { render } from "./icons-filter.svg?vue&type=template&id=791ebc9c?inline"
const script = {}
script.render = render

export default script